var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconNeighbor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1494_202195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1494_202195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95004 12.3833L7.10004 13.4333C7.3556 13.6778 7.6556 13.8 8.00004 13.8C8.34449 13.8 8.64449 13.6778 8.90004 13.4333L10.0334 12.4C11.2334 11.3222 12.3056 10.25 13.25 9.18333C14.1945 8.11667 14.6667 6.94444 14.6667 5.66667C14.6667 4.62222 14.3167 3.75 13.6167 3.05C12.9167 2.35 12.0445 2 11 2C10.4112 2 9.8556 2.125 9.33337 2.375C8.81115 2.625 8.36671 2.96667 8.00004 3.4C7.63337 2.96667 7.18893 2.625 6.66671 2.375C6.14449 2.125 5.58893 2 5.00004 2C3.9556 2 3.08337 2.35 2.38337 3.05C1.68337 3.75 1.33337 4.62222 1.33337 5.66667C1.33337 6.94444 1.80837 8.11389 2.75837 9.175C3.70837 10.2361 4.77226 11.3056 5.95004 12.3833Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconNeighbor);
export default __webpack_public_path__ + "static/media/profile-icon-neighbor.e02da99594c38dda3db372389df14dfb.svg";
export { ForwardRef as ReactComponent };